import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { forwardRef } from 'react';
import { Box } from '../Box/index.js';

/* ======================================= */
/**
 * Used in pattern components like Card and Accordion
 */
const getCardStyles = variant => {
  switch (variant) {
    case 'outline':
      return {
        border: '1px solid',
        borderColor: 'divider'
      };
    case 'shadow':
      return {
        boxShadow: 'medium'
      };
    case 'ghost':
    default:
      return {};
  }
};
/* ======================================= */
/**
 * The Card component is a styled container that serves as the
 * entry point for detailed information.
 *
 * ### Documentation
 * - [Examples](https://blockparty.endpoint.com/components/card#usage)
 * - [Props](https://blockparty.endpoint.com/components/card#props)
 * <br />
 *
 */
const Card = /*#__PURE__*/forwardRef((_ref, forwardedRef) => {
  let {
    children,
    variant = 'shadow',
    dataTestId = 'card',
    ...rest
  } = _ref;
  const cardStyles = getCardStyles(variant);
  return /*#__PURE__*/React__default.createElement(Box, _extends({
    ref: forwardedRef,
    bg: "background",
    borderRadius: "radiusDefault",
    "data-test-id": dataTestId
  }, cardStyles, rest), children);
});

export { Card, getCardStyles };
